export const wcag = {
    skiplinks: skiplinks,
    checkContrast: checkContrast
};

function skiplinks() {
    const allLinks = document.querySelectorAll("[data-skiplink]");
    const sLinksCont = document.querySelector("[data-skiplinks-list]");

    if (sLinksCont) {
        sLinksCont.innerHTML = "";
    }

    [].forEach.call(allLinks, el => {
        if (el.getAttribute("data-skiplink") !== "") {
            let li = document.createElement("li");
            li.innerHTML =
                '<a href="#' +
                el.getAttribute("id") +
                '" >' +
                el.getAttribute("data-skiplink") +
                "</a>";
            sLinksCont.appendChild(li);
        }
    });

    const sLinks = sLinksCont.querySelectorAll("a");
    [].forEach.call(sLinks, el => {
        el.addEventListener("click", function(e) {
            const dest = document.querySelector(
                "" + e.currentTarget.getAttribute("href")
            );
            if (e.currentTarget.getAttribute("href") === "#search-main-b2b") {
                document.querySelector("[data-btn=searchInput]").click();
                setTimeout(() => {
                    dest.focus();
                }, 1000);
            } else {
                dest.setAttribute("tabindex", "0");
                dest.focus();
            }
        });
    });
}

function checkContrast() {
    // let el = document.createElement('div');
    // el.setAttribute("id", "systemMode");
    // el.setAttribute('background-image', 'url(../images/placeholder.gif)');
    // document.body.appendChild(el);
    // console.log('kontr ', document.querySelector('#systemMode').style.backgroundImage)
    // if (document.querySelector('#systemMode').style.backgroundImage === '') {
    // 	document.body.classList.add('contrast-mode');
    // }
}